/**
 * `/program/*` routes v2 calls (API_ACCESS.md §3.1), held to the snapshot by `api/routes.test.ts`.
 */
import { gated } from "../../capabilities/access";
import { defineRoutes, route } from "../route";

export const PROGRAM = defineRoutes("program", {
  fetch: route<undefined, Record<string, unknown>>("GET", "/program/fetch", gated({ modules: ["Account", "Settings", "Order", "Sale"] }), {
    notes:
      "the loyalty programme of a channel, as `?channelDefId=`: always DotPe's (`GET loyalty/s2s/programs?brandId=`), its body as it is, or ERR_INVALID_BRAND when the channel has no brand (customer_controller.js:537-563; api_dotpe_service.js:1471-1520)",
  }),
});
